"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var i_vc_cms_service_1 = require("./i-vc-cms.service");
var constants_1 = require("../utilities/constants");
var network_service_1 = require("./network.service");
var NetworkServiceImpl = /** @class */ (function (_super) {
    __extends(NetworkServiceImpl, _super);
    function NetworkServiceImpl(applicationPropertiesService, http, vcCmsService) {
        var _this = _super.call(this) || this;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.http = http;
        _this.vcCmsService = vcCmsService;
        _this.CONFERENCE_SERVICE_URI_KEY = 'video-conference-service-url';
        _this.CONNECTION_CREATE_URL = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/session/connect/?token=", ""], ["", "/session/connect/?token=", ""])), 'serviceUri', 'token');
        _this.SESSION_STATUS_URL = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/session/", "/status"], ["", "/session/", "/status"])), 'serviceUri', 'roomId');
        return _this;
    }
    NetworkServiceImpl.prototype.createConnection = function (roomId) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var tokenResponse, status, token, serviceUri, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.vcCmsService.getSessionToken(roomId)];
                    case 1:
                        tokenResponse = _a.sent();
                        status = tokenResponse.status;
                        if (!constants_1.AppConstants.isOk(status)) {
                            reject("Unable to connect.");
                            return [2 /*return*/];
                        }
                        token = tokenResponse.token;
                        return [4 /*yield*/, this.applicationPropertiesService.getProperty(this.CONFERENCE_SERVICE_URI_KEY)];
                    case 2:
                        serviceUri = _a.sent();
                        url = this.CONNECTION_CREATE_URL.replaceTemplate({
                            serviceUri: serviceUri,
                            token: token
                        });
                        this.http.post(url, null).subscribe({
                            next: function (connection) {
                                resolve(connection);
                            },
                            error: function (error) {
                                reject(error);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    NetworkServiceImpl.prototype.getSessionStatus = function (roomId) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var serviceUri, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.applicationPropertiesService.getProperty(this.CONFERENCE_SERVICE_URI_KEY)];
                    case 1:
                        serviceUri = _a.sent();
                        url = this.SESSION_STATUS_URL.replaceTemplate({
                            serviceUri: serviceUri,
                            roomId: roomId
                        });
                        this.http.get(url).subscribe({
                            next: function (status) {
                                resolve(status);
                            },
                            error: function (error) {
                                console.warn(error);
                                reject(error);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    NetworkServiceImpl = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.HttpClientWrapper,
            i_vc_cms_service_1.IVCCmsService])
    ], NetworkServiceImpl);
    return NetworkServiceImpl;
}(network_service_1.NetworkService));
exports.NetworkServiceImpl = NetworkServiceImpl;
var templateObject_1, templateObject_2;
//# sourceMappingURL=network.service.impl.js.map